import { render, staticRenderFns } from "./ProfileUpdatePushToken.vue?vue&type=template&id=2315981f&scoped=true"
import script from "./ProfileUpdatePushToken.vue?vue&type=script&lang=js"
export * from "./ProfileUpdatePushToken.vue?vue&type=script&lang=js"
import style0 from "./ProfileUpdatePushToken.vue?vue&type=style&index=0&id=2315981f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2315981f",
  null
  
)

export default component.exports